"use strict";

// eslint-disable-next-line no-empty-function
module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/function/noop.js
// module id = 5
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es5-ext/function/noop.js